import { jsx } from "react/jsx-runtime";
import { useAddressLabel } from "../../../hooks/use-address-label.js";
import { useCountryCode } from "../../multiline-address/multiline-address/country-code-context.js";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const MlaCityWUT = (props) => {
  const fieldType = FIELD_TYPES.MLA_CITY;
  const label = useAddressLabel("city");
  const countryCode = useCountryCode();
  return /* @__PURE__ */ jsx(
    TextInputFieldWUT,
    {
      ...props,
      fieldType,
      label,
      countryCode
    }
  );
};
export {
  MlaCityWUT
};
//# sourceMappingURL=mla-city-wut.js.map
